import { Column, Entity, PrimaryColumn } from 'typeorm';

import { TenantIdSchemaBase } from '../interfaces/tenantId.base';
import { IndividualReportSchema } from './individual-report.schema';
import { InspectionSchema } from './inspection.schema';
import { InspectionImageSchema } from './inspectionImage.schema';

export enum UploadDataType {
  Inspection = 1,
  InspectionImageInfo = 2,
  InspectionImageFile = 3,
  InspectionModifiedImageFile = 4,
  IndividualReport = 5,
  InspectionMeasurementImageFile = 6,
  InspectionMeasurementImageAudioFile = 7,
  InspectionThumbnailImageFile = 8,
  InspectionModifiedThumbnailImageFile = 9,
  InspectionMeasurementThumbnailImageFile = 10
}

@Entity()
export class UploadManagementSchema implements TenantIdSchemaBase {

  @PrimaryColumn()
    id: string;

  @Column({ nullable: true })
    type: UploadDataType | null;

  @Column({ nullable: true })
    dataId: string | null;

  @Column({ nullable: true })
    parentDataId: string | null;

  @Column({ nullable: true })
    isUploaded: boolean | null;

  @Column({ nullable: true })
    ErrorCode: string | null;

  @Column({ nullable: true })
    tenantId: string | null;

  @Column({ nullable: true })
    isDeleted: boolean | null;

  @Column({ nullable: true })
    isOfflineData: boolean | null;

  @Column({ nullable: true })
    manageUserId: string | null;

  constructor(dataId: string, tenantId: string, type: UploadDataType, isOfflineData: boolean,
    manageUserId: string, parentDataId: string = null) {
    this.id = `${dataId}_${type}`;
    this.dataId = dataId;
    this.tenantId = tenantId;
    this.type = type;
    this.parentDataId = parentDataId;
    this.ErrorCode = '';
    this.isUploaded = false;
    this.isDeleted = false;
    this.isOfflineData = isOfflineData;
    this.manageUserId = manageUserId;
  }
}

/**
 * 同期に失敗したデータを保持
 */
export class OfflineDataSyncErrorObject {
  inspectionId: string;

  inspectionSchema: InspectionSchema;

  inspectionImageSchemaList: Array<InspectionImageSchema>;

  individualReportSchemaList: Array<IndividualReportSchema>;
  constructor() {
    this.individualReportSchemaList = [];
    this.inspectionImageSchemaList = [];
  }
}
